// ============================================================
// useSocket — connexion Socket.IO authentifiée (live updates)
// ============================================================

import { useEffect, useRef, useState } from 'react';
import { io, type Socket } from 'socket.io-client';
import { getAccessToken, onTokenChange } from '../api';
import { API_BASE as SOCKET_URL } from '../apiBase';

export function useSocket(): { socket: Socket | null; connected: boolean } {
  const socketRef = useRef<Socket | null>(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    function connect(token: string | null): void {
      socketRef.current?.disconnect();
      if (!token) {
        socketRef.current = null;
        setConnected(false);
        return;
      }
      const s = io(SOCKET_URL, {
        auth: { token },
        transports: ['websocket'],
        withCredentials: true,
      });
      s.on('connect', () => setConnected(true));
      s.on('disconnect', () => setConnected(false));
      socketRef.current = s;
    }

    connect(getAccessToken());
    const off = onTokenChange((t) => connect(t));
    return () => {
      off();
      socketRef.current?.disconnect();
      socketRef.current = null;
    };
  }, []);

  return { socket: socketRef.current, connected };
}
